import RestApi from '@/core/services/RestApi'
import { projectEndpoint, isValidUrl } from '@/core/helpers'
import { $hasFeature } from '@/core/utils/VueAcl'

export const validationMixin = {
  methods: {
    validateColumns(rule, value, callback) {
      if (this.currentStepName !== 'data_mapping') {
        callback()
        return
      }

      const endpoint = projectEndpoint({
        method: 'post',
        url: `imports/validate`,
        data: {
          ...this.model
        }
      })

      RestApi(endpoint)
        .then(() => {
          callback()
        })
        .catch(error => {
          let errorJson = JSON.parse(error.message)
          this.highlightAffectedProfileAttribute(errorJson.attribute)
          this.$message({
            message: errorJson.message,
            type: 'error'
          })

          callback(new Error(`${errorJson.attribute} ${errorJson.message}.`))
        })
    },

    validateUserIdCol(rule, value, callback) {
      if (this.currentStepName !== 'data_mapping') {
        callback()
        return
      }

      const requireUserId = $hasFeature('profileRequireUserId')

      const isValid = requireUserId
        ? value.some(e => e.attribute === 'user_id')
        : value.some(
            e =>
              e.attribute === 'user_id' ||
              (e.attribute === 'customer_id' &&
                $hasFeature('customerIdEnabled')) ||
              (e.attribute === 'email' && $hasFeature('profileIdfybyEmail'))
          )

      if (isValid) {
        callback()
        return
      }

      const customerIdEnabled =
        !requireUserId && $hasFeature('customerIdEnabled')
      const emailEnabled = !requireUserId && $hasFeature('profileIdfybyEmail')

      let messageKey = 'Imports_Message_IdRequired_UserId'
      if (customerIdEnabled && emailEnabled) {
        messageKey = 'Imports_Message_IdRequired_UserIdOrCustomerIdOrEmail'
      } else if (customerIdEnabled) {
        messageKey = 'Imports_Message_IdRequired_UserIdOrCustomerId'
      } else if (emailEnabled) {
        messageKey = 'Imports_Message_IdRequired_UserIdOrEmail'
      }

      this.$message({
        message: this.$t(messageKey),
        type: 'error'
      })
    },

    validateEventCol(rule, value, callback) {
      const isEventDataMappingStep =
        this.currentStepName === 'data_mapping' && this.model.type === 'events'

      if (!isEventDataMappingStep) {
        callback()
        return
      }

      if (value.some(e => e.attribute === 'timestamp')) {
        callback()
        return
      }

      this.$message({
        message: this.$t('Imports_Message_EventColsNotAssigned'),
        type: 'error'
      })
    },

    validateAutomationName(rule, value, callback) {
      const automationId = this.$route.query.id || null

      if (!value) return

      let endpoint = projectEndpoint({
        method: 'get',
        url: `import-automations`,
        params: {
          name: value
        }
      })

      RestApi(endpoint)
        .then(({ data }) => {
          const existingAutomationNames = data.map(e => e.name)
          const isNameTaken = existingAutomationNames.includes(value)

          if (!isNameTaken) {
            callback()
            return
          }

          if (automationId) {
            const matchingAutomation = data.find(e => e.name === value)
            if (matchingAutomation.id === parseInt(automationId)) {
              callback()
              return
            }
          }

          callback(
            new Error(`${value} ${this.$t('RestForm_FieldNameExists')}.`)
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    validateDeltaColumn(rule, value, callback) {
      if (this.model.source.sync_mode === 'delta' && !value) {
        callback(new Error(this.$t('RestForm_FieldIsRequired')))
      } else {
        callback()
      }
    },

    validateUrl(rule, value, callback) {
      if (!isValidUrl(value)) {
        callback()
        return
      }

      callback(new Error(this.$t('RestForm_FieldInvalidUrl')))
    },

    validateEventField(rule, value, callback) {
      if (this.model.type === 'events' && !value) {
        callback(new Error(`${this.$t('Automations_Import_Event_Required')}.`))
      } else {
        callback()
      }
    },

    highlightAffectedProfileAttribute(field) {
      let oldAffected = document.querySelectorAll(
        '.Profile_Attribute_Input_Error'
      )
      oldAffected.forEach(function(el) {
        el.classList.remove('Profile_Attribute_Input_Error')
      })

      document
        .getElementById(field + '--Input')
        .classList.add('Profile_Attribute_Input_Error')
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/imports/mixins/ValidationMixin.js